import { render, staticRenderFns } from "./VendorOverview.vue?vue&type=template&id=124e3a59&scoped=true&"
import script from "./VendorOverview.vue?vue&type=script&lang=js&"
export * from "./VendorOverview.vue?vue&type=script&lang=js&"
import style0 from "./VendorOverview.vue?vue&type=style&index=0&id=124e3a59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e3a59",
  null
  
)

export default component.exports